module.exports = __webpack_public_path__ + "img/undraw_web_developer_p3e5.f7f12d8b.svg";